import { DuLieuHeThong, TrangChu } from 'api';
import { DropDownTreeSelectOneElement, DropDown } from 'components/tt-forms/common';
import { MasterLayout } from 'layout';
import { get, isEmpty } from 'lodash';
import { Card } from 'modules/home';
import React from 'react';
import cookie from 'react-cookie';
import { browserHistory } from 'react-router';
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from "recharts";
import './style.scss';

class Home extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      dataOptions: [],
      coQuanQuanLyID: null,
      countKeHoachThanhTra: null,
      countDanhMucCuocThanhTra: null,
      countTheoDoiCuocThanhTra: null,
      countTheoDoiCuocThanhTraTheoNam: [],
      isShowComboxboxDonVi: false,
      listNamThanhTra: [],
      namThanhTra: new Date().getFullYear(),
    }
  }

  getListDV() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    DuLieuHeThong.actions.getDonViThongKe.request().then(res => {
      if (res.data._embedded) {
        let dataDonVi = [...res.data._embedded.coQuanQuanLies]
        let DonVi = dataDonVi.filter(state => {
          return state.coQuanQuanLyId == userInfo.donViId
        })
        this.setState({
          dataSelected: [
            { value: DonVi.length > 0 ? DonVi[0].coQuanQuanLyId : '', label: DonVi.length > 0 ? DonVi[0].ten : '' }
          ],
          dataOptions: res.data._embedded.coQuanQuanLies
        })
      }
    });
  }

  onChange(name, e) {
    if (name == 'DonVi') {
      this.setState({
        coQuanQuanLyID: e.target.value
      });
    }
    if (name == 'namThanhTra') {
      this.setState({
        namThanhTra: e.target.value
      })
    }
  }

  componentDidMount() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    this.setState({ coQuanQuanLyID: userInfo.donViId || null })
    if (typeof cookie.load('accessToken') === 'undefined') {
      browserHistory.push('/dang-nhap');
    } else {
      this.getCheckLuaChonDonVi();
      this.getListDV();
      this.getCountKeHoachThanhTra();
      this.getCountDanhMucCuocThanhTra();
      this.getCountTheoDoiCuocThanhTra();
      this.getCountTheoDoiCuocThanhTraTheoNam();
      this.getNamThanhTra();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.coQuanQuanLyID !== this.state.coQuanQuanLyID || prevState.namThanhTra !== this.state.namThanhTra) {
      this.getCheckLuaChonDonVi();
      this.getCountKeHoachThanhTra();
      this.getCountDanhMucCuocThanhTra();
      this.getCountTheoDoiCuocThanhTra();
      this.getCountTheoDoiCuocThanhTraTheoNam();
    }
  }

  getCountKeHoachThanhTra() {
    TrangChu.actions.getCountKeHoachThanhTra.request(null, { donViId: this.state.coQuanQuanLyID, namThanhTra: this.state.namThanhTra }).then(res => {
      const { data } = res;
      if (!isEmpty(data)) {
        this.setState({
          countKeHoachThanhTra: data,
        });
      }
    })
  }

  getCountDanhMucCuocThanhTra() {
    TrangChu.actions.getCountDanhMucCuocThanhTra.request(null, { donViId: this.state.coQuanQuanLyID, namThanhTra: this.state.namThanhTra }).then(res => {
      const { data } = res;
      if (!isEmpty(data)) {
        this.setState({
          countDanhMucCuocThanhTra: data,
        });
      }
    })
  }

  getCountTheoDoiCuocThanhTra() {
    TrangChu.actions.getCountTheoDoiCuocThanhTra.request(null, { donViId: this.state.coQuanQuanLyID, namThanhTra: this.state.namThanhTra }).then(res => {
      const { data } = res;
      if (!isEmpty(data)) {
        this.setState({
          countTheoDoiCuocThanhTra: data,
        });
      }
    })
  }

  getCountTheoDoiCuocThanhTraTheoNam() {
    TrangChu.actions.getCountTheoDoiCuocThanhTraTheoNam.request(null, { donViId: this.state.coQuanQuanLyID }).then(res => {
      const { data } = res;
      if (!isEmpty(data)) {
        this.setState({
          countTheoDoiCuocThanhTraTheoNam: data.map(item => ({
            'Số cuộc Thanh Tra': item.totalCountCuocThanhTra,
            name: item.namThanhTra
          })),
        });
      }
    })
  }

  getCheckLuaChonDonVi() {
    TrangChu.actions.getCheckLuaChonDonVi.request(null, {}).then(res => {
      const { data } = res;
      this.setState({
        ...this.state,
        isShowComboxboxDonVi: data,
      });
    })
  }

  getNamThanhTra() {
    DuLieuHeThong.actions.getNamThanhTra.request(null, {}).then(res => {
      const { data } = res;
      if (!isEmpty(data)) {
        this.setState({
          listNamThanhTra: data,
        });
      }
    })
  }

  render() {
    const { countKeHoachThanhTra, countDanhMucCuocThanhTra, countTheoDoiCuocThanhTra, countTheoDoiCuocThanhTraTheoNam } = this.state;
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="home-page" ref="home">
          <div className='home-header'>
            <h2 className='home-header__title'>Trang chủ</h2>
            <div className='home-search'>
              {/* <div className='home-search-group'>
                <span className='home-search-group__label'>Từ ngày</span>
                <DatePicker />
              </div>
              <div className='home-search-group'>
                <span className='home-search-group__label'>Đến ngày</span>
                <DatePicker />
              </div> */}
              <div className='home-search-group'>
                <span className='home-search-group__label'>Năm</span>
                <DropDown className="combobox-nam-thanh-tra" label="" selectedValue={this.state.namThanhTra} placeholder={null} onChange={this.onChange.bind(this, 'namThanhTra')} options={this.state.listNamThanhTra} valueName="ten" keyName="giaTri" />
              </div>
              {
                this.state.isShowComboxboxDonVi && (
                  <div className='home-search-group'>
                    <span className='home-search-group__label'>Đơn vị</span>
                    <DropDownTreeSelectOneElement className='col-6 mb0-18 tree-selected' dataOptions={this.state.dataOptions} value={this.state.coQuanQuanLyID} onChange={this.onChange.bind(this, 'DonVi')} propertyChildren='coQuanQuanLyCha' propertyParent='coQuanQuanLyId' />
                  </div>
                )
              }
            </div>
          </div>
          <div className='home-content'>
            <h3 className='home-content__title'>Kế hoạch thanh tra</h3>
            <div className='cards'>
              <Card title="Tổng kế hoạch thanh tra"
                titleColor="#fff"
                icon="tt-documentation"
                bgIcon="#80b7e3"
                total={get(countKeHoachThanhTra, 'totalCount', 0) || 0}
                totalColor="#fff"
                bgColor="#016FC6"
              />
              <Card title="Đã có quyết định"
                titleColor="rgba(25, 40, 47, 0.6)"
                icon="tt-document-check"
                bgIcon="#05C1B2"
                total={get(countKeHoachThanhTra, 'countDaCoQuyetDinh', 0) || 0}
                totalColor="#19282F"
                bgColor="#fff"
              />
              <Card title="Chưa có quyết định"
                titleColor="rgba(25, 40, 47, 0.6)"
                icon="tt-document-time"
                bgIcon="#3C47BB"
                total={get(countKeHoachThanhTra, 'countChoRaQuyetDinh', 0) || 0}
                totalColor="#19282F"
                bgColor="#fff"
              />
            </div>
            <h3 className='home-content__title'>Danh mục cuộc thanh tra</h3>
            <div className='cards'>
              <Card title="Tổng cuộc thanh tra"
                titleColor="#fff"
                icon="tt-document-search"
                bgIcon="#88c3fc"
                total={get(countDanhMucCuocThanhTra, 'totalCountCuocThanhTra', 0) || 0}
                totalColor="#fff"
                bgColor="#1187F8"
              />
              <Card title="Theo kế hoạch"
                titleColor="rgba(25, 40, 47, 0.6)"
                icon="tt-calendar"
                bgIcon="#05C1B2"
                total={get(countDanhMucCuocThanhTra, 'totalCountCuocThanhTraKeHoach', 0) || 0}
                totalColor="#19282F"
                bgColor="#fff"
                extend
                totalDone={get(countDanhMucCuocThanhTra, 'totalCountCuocThanhTraKeHoachDaHoanThanh', 0) || 0}
                totalInprogress={get(countDanhMucCuocThanhTra, 'totalCountCuocThanhTraKeHoachDangThanhTra', 0) || 0}
              />
              {/* <Card title="Thường xuyên"
                titleColor="rgba(25, 40, 47, 0.6)"
                icon="tt-clock"
                bgIcon="#FFCF2F"
                total={get(countDanhMucCuocThanhTra, 'totalCountCuocThanhTraThuongXuyen', 0) || 0}
                totalColor="#19282F"
                bgColor="#fff"
                extend
                totalDone={get(countDanhMucCuocThanhTra, 'totalCountCuocThanhTraThuongxuyenDaThanhTra', 0) || 0}
                totalInprogress={get(countDanhMucCuocThanhTra, 'totalCountCuocThanhTraThuongxuyenDangThanhTra', 0) || 0}
              /> */}
              <Card title="Đột xuất"
                titleColor="rgba(25, 40, 47, 0.6)"
                icon="tt-deadline"
                bgIcon="#FD6114"
                total={get(countDanhMucCuocThanhTra, 'totalCountCuocThanhTraDotXuat', 0) || 0}
                totalColor="#19282F"
                bgColor="#fff"
                extend
                totalDone={get(countDanhMucCuocThanhTra, 'totalCountCuocThanhTraDotXuatDaThanhTra', 0) || 0}
                totalInprogress={get(countDanhMucCuocThanhTra, 'totalCountCuocThanhTraDotXuatDangThanhTra', 0) || 0}
              />
            </div>
            <h3 className='home-content__title'>Theo dõi cuộc thanh tra</h3>
            <div className='cards'>
              <Card title="Tổng cuộc thanh tra"
                titleColor="#fff"
                icon="tt-document-duplicate"
                bgIcon="#82e0d8"
                total={get(countTheoDoiCuocThanhTra, 'totalCount', 0) || 0}
                totalColor="#fff"
                bgColor="#05C1B2"
              />
              <Card title="Hoàn thành"
                titleColor="rgba(25, 40, 47, 0.6)"
                icon="tt-check-list"
                bgIcon="#016FC6"
                total={get(countTheoDoiCuocThanhTra, 'totalCountCuocThanhTra', 0) || 0}
                totalColor="#19282F"
                bgColor="#fff"
              />
              <Card title="Đang theo dõi"
                titleColor="rgba(25, 40, 47, 0.6)"
                icon="tt-clipboard"
                bgIcon="#D42991"
                total={get(countTheoDoiCuocThanhTra, 'totalCountCuocThanhTraTheoDoi', 0) || 0}
                totalColor="#19282F"
                bgColor="#fff"
              />
            </div>
            <div className='chart' style={{ width: '100%', height: "432px" }}>
              <h3 className='chart__title'>Biểu đồ Tổng số cuộc thanh tra theo năm</h3>
              <ResponsiveContainer>
                <BarChart width={900} height={432} data={countTheoDoiCuocThanhTraTheoNam} barSize={37} margin={{
                  top: 0,
                  right: 0,
                  left: 0,
                  bottom: 30
                }}>
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="Số cuộc Thanh Tra" fill="#016FC6" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </MasterLayout>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/modules/home/Home.jsx